import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  termsAndPolicy: { data: {} },
  companyDetails: { data: {} },
  registerLink: { data: {} },
  sponsor: { data: {} },
  forUser: {},
  forUserAddress:{}
};

const userSlice = createSlice({
  name: 'termsAndPolicy',
  initialState,
  reducers: {
    setTermsAndPolicy: (state, action) => {
      state.termsAndPolicy = { terms: action.payload?.terms, policy: action.payload?.policy }
    },
    setCompanyDetails: (state, action) => {
      state.companyDetails = action.payload
    },
    setRegisterLink: (state, action) => {
      state.registerLink = action.payload
    },
    setSponsor: (state, action) => {
      state.sponsor = action.payload
    },
    setForUser: (state, action) => {
      state.forUser = action.payload
    },
    setForUserAddress: (state, action) => {
      state.forUserAddress = action.payload
    }
  },
});

export const { setTermsAndPolicy, setCompanyDetails, setRegisterLink, setSponsor, setForUser, setForUserAddress } = userSlice.actions;

export default userSlice.reducer;
